module.exports = __webpack_public_path__ + "img/image-next-white.0f99edb7.png";